import { Injectable } from '@angular/core';
import { ClientBaseApiService } from 'src/app/core/api/client-base-api.service';
import { HttpRequestTypes } from 'src/app/core/models/enums/http-request-types';
import { environment } from 'src/environments/environment';
import { Pheromone, PheromoneRequest } from '../models/pheromone-lure';

@Injectable({
  providedIn: 'root'
})
export class PheromoneLureService {

  constructor(private clientService: ClientBaseApiService) { }

  getPheromoneList(deviceId) {
    let url = environment.baseApiUrl + "v2/api/device/trap/feromon/logs/" + deviceId;
    return this.clientService.baseApiCall<Pheromone[]>({ url, payload: {}, requestType: HttpRequestTypes.GET })
  }
  savePheromone(payload: PheromoneRequest) {
    let url = environment.baseApiUrl + "v2/api/device/trap/feromon/logs/save";
    return this.clientService.baseApiCall<PheromoneRequest>({ url, payload: payload, requestType: HttpRequestTypes.POST })
  }
  deletePheromone(deviceId) {
    let url = environment.baseApiUrl + "v2/api/device/trap/stickytrap/delete/logs/" + deviceId;
    return this.clientService.baseApiCall<PheromoneRequest>({ url, payload: {}, requestType: HttpRequestTypes.GET })
  }
}
